import { config } from "./config";
export const validationRules = {
    required: (value) =>
        value.trim() !== "" || "This field is required",

    email: (value) =>
        /\S+@\S+\.\S+/.test(value) || "Invalid email format",

    confirmEmail: (getEmail) => (value) =>
        value === getEmail() || "Emails do not match",

    asyncEmailBlacklistCheck: async (value, context = 'membership') => {
        // You can replace with your API endpoint
        const res = await fetch(`${config.apiBaseUrl}blacklist-email`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: value, context }),
        }).then((r) => r.json());
        return res.valid || res.message;
    },
};